<script setup lang="ts">
import { onMounted, ref, type PropType, type Ref, watch } from 'vue';

import type { Locales } from '@/services/types/api.types';

const props = withDefaults(
  defineProps<{
    hasValidationErrors: { [Locale in Locales]?: boolean };
    languageEnabled: Locales[];
  }>(),
  {
    hasValidationErrors: () => ({}),
    languageEnabled: () => [],
  },
);

const locales: Ref<Locales[]> = ref([]);
const selectedLocale = defineModel<Locales>({
  type: String as PropType<Locales>,
});

onMounted(() => {
  props.languageEnabled.forEach((locale) => locales.value.push(locale));
});

watch(
  () => props.languageEnabled,
  (newValue) => (locales.value = newValue),
);

const handleClick = (locale: Locales) => {
  selectedLocale.value = locale;
};
</script>
<template>
  <div>
    <q-btn-group flat>
      <q-btn
        v-for="locale in locales"
        :key="locale"
        :class="{
          'language-switcher__selected': locale === selectedLocale,
          'language-switcher__button': true,
        }"
        @click="handleClick(locale)"
        flat
      >
        <q-badge v-if="props.hasValidationErrors[locale]" color="red" rounded floating>! </q-badge>
        {{ locale.toUpperCase() }}
      </q-btn>
    </q-btn-group>
  </div>
</template>
<style lang="scss">
.language-switcher__selected {
  background-color: $primary !important;
  color: white !important;
}

.language-switcher__button {
  border-color: $primary !important;
  border-width: 1px !important;
  border-style: solid !important;

  &:not(:first-child):not(:last-child) {
    border-left: none !important;
    border-right: none !important;
  }
}
</style>
